import React, { useMemo } from 'react';
import ExistingStockDocumentationAccordion from './subComponents/existingStock/ExistingStockDocumentationAccordion';
import ExistingStockCharts from './subComponents/existingStock/ExistingStockCharts';
import LoadingState from './subComponents/existingStock/states/LoadingState';
import ErrorState from './subComponents/existingStock/states/ErrorState';

const ExistingStockTab = ({
  country,
  existingStockLoading,
  existingStockError,
  existingStockData,
  onRetry,
  ChartCard
}) => {

  const documentationSection = useMemo(() => (
    <ExistingStockDocumentationAccordion />
  ), []);
  
  const ExistingStockChartsComponent = useMemo(() => {
    return (
      <ExistingStockCharts
        existingStockData={existingStockData}
        ChartCard={ChartCard}
      />
  )}, [existingStockData, ChartCard]);

  if (!country) {
    return (
      <LoadingState message="Loading country data..." />
    );
  }

  if (existingStockLoading) {
    return (
      <LoadingState message="Loading existing stock data..." />
    );
  }

  if (existingStockError) {
    return (
      <ErrorState
        message={existingStockError}
        onRetry={() => onRetry(country.iso_code)}
      />
    );
  }

  return (
    <div className="w-full min-w-0 overflow-hidden px-2 md:px-4 lg:px-6 py-2 md:py-4 lg:py-6">

      {/* Existing Stock Charts */}
      {ExistingStockChartsComponent}

      {/* Documentation Section */}
      {documentationSection}

    </div>
  );
};


export default ExistingStockTab;